import {useQuery} from 'react-query';
import getMyStoreStoreLabNotifModal from '.';

interface IuseGetMyStoreStoreLabNotifModal {
  data?: ISupplier_profile;
}

const useGetMyStoreStoreLabNotifModal = ({
  data: storeAndLabData,
}: IuseGetMyStoreStoreLabNotifModal) => {
  const {data, isLoading} = useQuery(
    ['get-myStore-store-lab-notif-modal'],
    getMyStoreStoreLabNotifModal,
    {
      enabled:
        storeAndLabData?.lab?.guid || storeAndLabData?.store?.guid
          ? true
          : false,
    },
  );

  return {
    storeAndLabModal: data,
    myStoreStoreLabNotifModalIsLoading: isLoading,
  };
};

export default useGetMyStoreStoreLabNotifModal;
